import { useLogout } from '@core/hooks/useLogout'
import { signInSearchSchema } from '@core/utils/sign-in-search'
import { ROUTES } from '@platform/router/paths'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN

export const Route = createFileRoute('/logout')({
  validateSearch: signInSearchSchema.pick({ redirect: true }),
  component: LogoutPage,
})

function LogoutPage() {
  const navigate = useNavigate()
  const { redirect } = Route.useSearch()

  useLogout({
    cognitoDomain,
    onNonSsoLogout: useCallback(
      () =>
        navigate({
          to: ROUTES.signIn,
          search: { redirect },
          viewTransition: false,
        }),
      [navigate, redirect]
    ),
  })

  return null
}
